import PropTypes from 'prop-types';

// material-ui
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

// ==============================|| KANBAN BACKLOGS - STORY DELETE ||============================== //

export default function DeleteEventDialog({ title, description, open, handleClose, onDelete, selectedEvent }) {
    return (
        <Dialog
            open={open}
            onClose={() => handleClose(false)}
            keepMounted
            maxWidth="xs"
            aria-labelledby="item-delete-title"
            aria-describedby="item-delete-description"
            data-test-id="views/admin/Events/components/DeleteEventDialog"
        >
            {open && (
                <>
                    <DialogTitle id="item-delete-title">{title}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="item-delete-description">{description}</DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{ mr: 2 }}>
                        <Button onClick={() => handleClose(false)} color="error">
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            size="small"
                            onClick={() => {
                                onDelete(selectedEvent.id, selectedEvent.type);
                                handleClose(true);
                            }}
                            autoFocus
                        >
                            Delete
                        </Button>
                    </DialogActions>
                </>
            )}
        </Dialog>
    );
}

DeleteEventDialog.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func,
    title: PropTypes.string,
    description: PropTypes.string
};
